import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const formRoutes: RouteRecordRaw[] = [
  {
    path: '/forms',
    name: 'forms',
    component: () => import('@/modules/forms/views/FormListView.vue'),
    meta: {
      title: 'Formulare',
      permission: PERMISSIONS.SETTINGS.VIEW,
      projectScoped: true,
    },
  },
  {
    path: '/forms/:id/submissions',
    name: 'forms-submissions',
    component: () => import('@/modules/forms/views/FormSubmissionsView.vue'),
    meta: {
      title: 'Odeslane formulare',
      permission: PERMISSIONS.CONTENT.VIEW,
      projectScoped: true,
    },
  },
]
